import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Snackbar, Alert } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { dismissToast } from '../../store/slices/notificationSlice';

const ToastNotification = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const toast = useSelector(state => state.notifications?.toast);

  if (!toast) return null;

  const handleClick = () => {
    dispatch(dismissToast());
    if (toast.deepLink) navigate(toast.deepLink);
  };

  return (
    <Snackbar
      open={!!toast}
      autoHideDuration={5000}
      onClose={() => dispatch(dismissToast())}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
    >
      <Alert
        severity="info"
        variant="filled"
        onClose={() => dispatch(dismissToast())}
        onClick={handleClick}
        sx={{ cursor: toast.deepLink ? 'pointer' : 'default', minWidth: 300 }}
      >
        <strong>{toast.title}</strong>
        <br />
        {toast.body}
      </Alert>
    </Snackbar>
  );
};

export default ToastNotification;
